import { twMerge } from 'tailwind-merge'
import type { ReactNode } from 'react'

interface NormalProgressBarStyle {
  value: number
  maxValue: number
  className?: string
}

interface NormalProgressBarProps {
  className?: string
  normalProgressBarStyle?: NormalProgressBarStyle
  children?: ReactNode
}

const NormalProgressBar = ({ className, normalProgressBarStyle, children }: NormalProgressBarProps) => {
  return (
    <div className={twMerge('w-full h-[6px] bg-gray-200 rounded-full', className)}>
      <div
        className={twMerge('h-full bg-[#FFA236] rounded-full', normalProgressBarStyle?.className)}
        style={{ width: `${((normalProgressBarStyle?.value ?? 0) / (normalProgressBarStyle?.maxValue ?? 1)) * 100}%` }}
      ></div>
      {children}
    </div>
  )
}

export default NormalProgressBar
